import React, { useState, useEffect } from 'react';
import { Text, View, Image, StyleSheet, Pressable } from 'react-native';
import { getImagePath, addFontFamilylato } from '../../utils/services/CommonUtils';

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { View as AnimatableView } from 'react-native-animatable';
import { CommonTextInput } from '../../utils/widgets/CommonTextInput';
import { BulletedDotView } from '../../utils/widgets/Common-Widget';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { Ampersand } from '../../utils/constants/AppConstants';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';

import Colors from '../../utils/constants/AppColors';

const OmsOffers = (props) => {

    const [typedOffer, setTypedOffer] = useState('');
    const [offersList, setOffersList]: any = useState([]);
    const [isInputValid, setIsInputValid]: any = useState(false);

    useEffect(() => {
        if (props?.route?.params?.offersList) {
            setOffersList(props?.route?.params?.offersList);
        }
    }, []);

    function applyOffer(offer) {
        global.appHandledBackpress = true;
        props.navigation.pop();
        props.route.params.getbackServiceChargeCB(offer);
    }

    function onChangeCouponCode(couponText) {
        setTypedOffer(couponText.toUpperCase());
        couponText.length >= 3 ? setIsInputValid(true) : setIsInputValid(false)
    }

    function toggleConditions(item, index) {
        offersList[index]['showTnC'] = !item.showTnC
        setOffersList(offersList.slice());
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth, height: '100%', minHeight: '100vh' }}>

            <CommonHeader navigation={props.navigation}
                specificScreenOnBackpress={ScreenRoute.view_order_details}
                title={`Apply Promo Code`} allowPopScreen={true}></CommonHeader>

            <View style={[AppStyles.screenViewWithHeader, AppStyles.bg]}>

                <View style={[AppStyles.flexRowSpaceBetween, AppStyles.bgWhite,
                { padding: 16, marginBottom: 16 }]}>
                    <CommonTextInput
                        width={AppTheme.appWidth - 108}
                        value={typedOffer}
                        placeholder={"Enter promo coupon"}
                        onChangeText={(text) => { onChangeCouponCode(text) }} />
                    <PrimaryCTA
                        width={68}
                        title={'APPLY'}
                        paddingVertical={16}
                        disabled={!isInputValid}
                        action={() => { applyOffer(typedOffer) }} />
                </View>


                {offersList.length > 0 ? <View style={[AppStyles.bgWhite, { paddingTop: 16 }]}>

                    <Text style={[TextStyle.text18xb, {
                        paddingHorizontal: 16
                    }]}>Available Coupon Codes</Text>

                    {offersList.map((offer: any, index) => (
                        <View key={index} style={{ paddingTop: 16 }}>

                            <View style={[AppStyles.flexRowSpaceBetween,
                            { paddingHorizontal: 16, marginBottom: 16 }]}>
                                <View style={[AppStyles.flexRowCenter]}>
                                    <View style={[AppStyles.bg, styles.offerIcon]}>
                                        <Image source={{ uri: offer.icon ?? getImagePath('/images/aayu_circle_blue.svg') }}
                                            style={{ width: 24, height: 24 }} /></View>
                                    <View style={[AppStyles.bg, AppStyles.dashedBorder, styles.offerText]}>
                                        <Text style={[TextStyle.text14b]}>{offer['code']}</Text></View>
                                </View>
                                <Text style={[TextStyle.text14xb, { color: Colors.primary }]}
                                    onPress={() => { applyOffer(offer.code) }}>APPLY</Text>
                            </View>

                            <View style={{ paddingHorizontal: 16 }}>
                                <Text style={[TextStyle.text16b, { marginBottom: 8 }]}>
                                    {offer.title}</Text>
                                <Text style={[TextStyle.text14, { marginBottom: 16, color: Colors.grey.text }]}>
                                    {offer.subTitle}</Text></View>

                            {offer.showTnC && <AnimatableView duration={AppTheme.transitionDuration}
                                animation={'fadeIn'} style={{ marginBottom: 8, paddingHorizontal: 16 }}>
                                <Text style={[TextStyle.text14b, { color: Colors.grey.text }]}>
                                    Terms {Ampersand} conditions</Text>
                                {offer?.tnc.map((condition) => {
                                    return <View key={offer['code'] + index}
                                        style={[AppStyles.flexRowStart]}>
                                        <BulletedDotView marginRight={16} />
                                        <Text style={[TextStyle.text12, { color: Colors.grey.text, flexWrap: "wrap" }]} >
                                            {condition}</Text>
                                    </View>
                                })}</AnimatableView>}

                            <Pressable style={[AppStyles.flexRowStart, { paddingHorizontal: 16 }]}
                                onPress={() => { toggleConditions(offer, index) }}>
                                <Text style={[TextStyle.text14xb, { color: Colors.primary, paddingRight: 4 }]} >
                                    {offer?.showTnC ? 'Show less' : 'Show more'} </Text>
                                <Image style={{
                                    transform: [{ rotate: offer?.showTnC ? '180deg' : '0deg' }],
                                    height: 6, width: 10
                                }} source={{ uri: getImagePath('/images/icons/blue-down-chevron.svg') }} />
                            </Pressable>

                            <View style={[AppStyles.bg, { height: 4, marginTop: 16 }]} />

                        </View>

                    ))}
                </View> : null}
            </View>
        </View >
    )
}

const styles = StyleSheet.create(addFontFamilylato({
    offerIcon: {
        borderRadius: 4, borderWidth: 2, padding: 6,
        borderColor: Colors.primary
    },
    offerText: {
        borderRadius: 4, borderWidth: 2,
        height: 40, padding: 10, marginLeft: 8, borderColor: Colors.primary
    }
}))

export default OmsOffers;